import React, { useEffect, useState } from "react";
import Providers from "../TabsCard/Providers";

import BaseCard from "../../../components/ui/BaseCard";
import BaseButton from "../../../components/ui/BaseButton";
import { brandPrimaryColor } from "../../../utils/variables";

const ProvidersTab = () => {
  return (
    <div className="h-screen">
      <BaseCard elevation={0} className="border py-2 sm:px-10 px-4 rounded-lg">
        <div className="grid grid-cols-2">
          <div className="items-center lg:col-span-1 col-span-2 grid grid-cols-12 gap-y-4 gap-x-6">
            <div className="sm:col-span-2 col-span-12">
              <BaseButton
                style={{
                  border: `1px solid ${brandPrimaryColor}`,
                  paddingTop: "4px",
                  paddingBottom: "4px",
                }}
                fullWidth={true}
                className="hover:bg-primary bg-white hover:text-white text-primary "
              >
                Route
              </BaseButton>
            </div>
            <div className="sm:col-span-2 col-span-12">
              <BaseButton
                style={{
                  border: `1px solid ${brandPrimaryColor}`,
                  paddingTop: "4px",
                  paddingBottom: "4px",
                }}
                fullWidth={true}
                className="hover:bg-primary bg-white hover:text-white text-primary"
              >
                Export
              </BaseButton>
            </div>
            <div className="xl:col-span-4 lg:col-span-6 sm:col-span-5 col-span-12">
              <BaseButton
                style={{
                  border: `1px solid ${brandPrimaryColor}`,
                  paddingTop: "4px",
                  paddingBottom: "4px",
                }}
                fullWidth={true}
                className="hover:bg-primary bg-white hover:text-white text-primary"
              >
                Invite to Recruitment
              </BaseButton>
            </div>
          </div>
        </div>
        <div className="block">{/* <BaseTextField /> */}</div>
      </BaseCard>
      <Providers />
    </div>
  );
};

export default ProvidersTab;
